import { SubProductAction } from "features/product/types/actions.subproduct";
import { TableColumn } from "features/product/types/subproductTable";
import { MultilingualString } from "features/shared/types/string";
import { useEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { useDispatch, useSelector } from "services/redux/rootReducer";
import useCurrentTableState from "../hooks/useCurrentTableState";
import { StyledInput } from "../inputs/inputs.styled";
import ArrowMenu from "./arrowMenu";
import { StyledHeaderCell } from "./header.styled";
import TooltipMenu from "./tooltipMenu";

interface Props {
    propertyColumn: TableColumn;
    idx: number;
}

const HeaderCell: React.FC<Props> = ({ propertyColumn, idx }) => {
    const [name, setName] = useState<MultilingualString>(propertyColumn.name);
    const [showTypes, setShowTypes] = useState<boolean>(false);

    const { locale, readOnlyMode } = useSelector((state) => state.subProducts);
    const { columns } = useCurrentTableState();
    const dispatch = useDispatch();

    useEffect(() => {
        setName(propertyColumn.name);
    }, [propertyColumn.name]);

    const handleCellUpdate = () => {
        // send the update to the columns
        if (readOnlyMode) return;
        dispatch({
            type: SubProductAction.ASSIGN_PROPERTY,
            propertyColumn: {
                ...propertyColumn,
                name,
            },
        });
    };

    return (
        <OutsideClickHandler onOutsideClick={() => setShowTypes(false)}>
            <StyledHeaderCell
                isFirst={idx === 0}
                isLast={idx === columns.length - 1}
                isHidden={propertyColumn.isHidden}
            >
                {showTypes && !readOnlyMode && <ArrowMenu idx={idx} />}
                <StyledInput
                    value={name[locale] || ""}
                    onFocus={() => !readOnlyMode && setShowTypes(true)}
                    onChange={(e) =>
                        setName({
                            ...name,
                            [locale]: e.target.value ?? "",
                        })
                    }
                    onBlur={handleCellUpdate}
                    placeholder="..."
                    disabled={readOnlyMode}
                />
                {showTypes && !readOnlyMode && (
                    <TooltipMenu propertyColumn={propertyColumn} idx={idx} />
                )}
            </StyledHeaderCell>
        </OutsideClickHandler>
    );
};

export default HeaderCell;
